import PropTypes from 'prop-types';
import React from 'react';
import { ApiDisplay, API_TYPES } from '../../../../../ApiDisplay';
import { FeedbackContainer } from '../../../../../Feedback';
import { ExternalLink } from '../../../../../PageElements/ExternalLink';
import { Text } from '../../../../../PageElements/Text';
import MemberDocs, { MemberTypes } from '../../../../../TypeDetails/MemberDocs';
import { NestedTable } from '../../../../../TypeDetails/NestedTable';
import { SectionContainer } from '../../../../../SectionContainer';
import { AuthorizationAndPermissions } from '../../../../../TypeDetails/OperationDetails/AuthorizationAndPermissions';
import { RpcRestTypeSwitch } from '../../../../../TypeDetails/OperationDetails/SyntaxDisplay/RpcRestTypeSwitch';
import style from '../../../../../TypeDetails/typeDetails.scss';
import get from 'lodash/get';

export const EventDetails = ({ message, hashPrefix, event, node }) => {
  const hasRest = get(event, 'extra.hasRest', true);

  return (
    <div className={style.typeDetails}>
      <MemberDocs
        memberType={MemberTypes.EVENT}
        memberObject={event}
        node={node}
      />
      <RpcRestTypeSwitch hasRest={hasRest} />
      <AuthorizationAndPermissions
        permissions={event.permissions}
        isEvent={true}
      />
      <ApiDisplay.REST showOnTypes={[API_TYPES.RPC_REST]}>
        <SectionContainer title="Event Body" titleDataHook="event-body-title">
          <Text dataHook="event-body-text">
            Event data is received as a JSON Web Token (JWT). It may be delayed.
            Be sure to{' '}
            <ExternalLink to="https://dev.wix.com/api/rest/getting-started/webhooks">
              verify the data was sent by Wix
            </ExternalLink>
            .
          </Text>
        </SectionContainer>
      </ApiDisplay.REST>
      <ApiDisplay.REST showOnTypes={[API_TYPES.RPC_REST, API_TYPES.RPC]}>
        <SectionContainer title="Event Data" titleDataHook="event-data-title">
          <NestedTable tableDepth={0} params={message?.members} />
        </SectionContainer>
      </ApiDisplay.REST>
      <FeedbackContainer memberId={hashPrefix} />
    </div>
  );
};

EventDetails.propTypes = {
  message: PropTypes.any,
  nodeExtra: PropTypes.any,
  artifactId: PropTypes.string,
  hashPrefix: PropTypes.string,
};
